// TAV-3491: the rollback points. Each one is shown on the Introduction step. Points with an acknowledgement
// must then be ticked one by one ("I acknowledge that ...") in the final confirm window before ROLL BACK can
// be typed.
export interface RollbackPoint {
  point: string;
  acknowledgement?: string;
}

export const ROLLBACK_POINTS: RollbackPoint[] = [
  {
    point: 'This cannot be undone. All rollback procedures are final and not recoverable.',
    acknowledgement: 'I acknowledge that this cannot be undone, and that the rollback is final and not recoverable.',
  },
  {
    point: 'All downloaded copies of existing statements will no longer be valid.',
    acknowledgement: 'I acknowledge that all downloaded copies of these statements will no longer be valid.',
  },
  {
    point:
      'All budget values at the time of generation will be re-calculated on the next statement generation. These may not be the same, as they are dictated by PRODA.',
    acknowledgement:
      'I acknowledge that budget values will be re-calculated on the next statement generation, and may not be the same, as they are dictated by PRODA.',
  },
  {
    point:
      'All services and reconciled items linked to these statements will be cleared. The next statement generation will re-calculate all reconciled services in range.',
    acknowledgement:
      'I acknowledge that all services and reconciled items linked to these statements will be cleared, and the next statement generation will re-calculate them.',
  },
  {
    point:
      'If any statement or item cannot be rolled back, nothing is rolled back. For example: a statement that has been emailed or has a later statement, or an item on a co-contribution invoice.',
    // No acknowledgement: the confirm window only opens once the check has passed, so it would always be true.
  },
  {
    point:
      'This link from TurnPoint Support only covers the month and clients shown. It can be used for one rollback only and expires 24 hours after it was created.',
    acknowledgement:
      'I acknowledge that this link only covers the month and clients shown, and will stop working once the rollback is done.',
  },
];

export const ROLLBACK_ACKNOWLEDGEMENTS = ROLLBACK_POINTS.flatMap(({ acknowledgement }) =>
  acknowledgement ? [acknowledgement] : [],
);
